import type { ReactNode } from 'react'
import { useCallback } from 'react'
import { rem } from 'polished'
import styled from 'styled-components'
import clsx from 'clsx'
import Group from 'components/utils/Group'
import CheckboxInput from 'LuxKit/Checkbox/CheckboxInput'
import Image from 'components/Common/Image'
import type { CartPanelItem } from '../hooks/useCartPanelItems'

const TileWrapper = styled.div`
  padding: ${rem(16)};

  &.deselected {
    opacity: 0.5;
  }
`

const TileContent = styled.div`
  display: grid;
  grid-template-columns: 1fr ${rem(80)};
  gap: ${rem(12)};
`

const ImageWrapper = styled.div`
  width: ${rem(80)};
  height: ${rem(80)};
  border-radius: ${props => props.theme.borderRadius.S};
  overflow: hidden;
  flex-shrink: 0;
`

interface Props {
  item: CartPanelItem
  onToggleInclude: (item: CartPanelItem) => void
  content: ReactNode
  attention: ReactNode | undefined
  actions: ReactNode | undefined
  price: ReactNode
  isToggleDisabled?: boolean
}

function CartPanelItemTileLayout({
  item,
  onToggleInclude,
  content,
  attention,
  actions,
  price,
  isToggleDisabled = false,
}: Props) {
  const handleCheckboxChange = useCallback(() => {
    onToggleInclude(item)
  }, [onToggleInclude, item])

  const isInteractive = !item.isBooked

  return (
    <TileWrapper className={clsx({ deselected: item.cartExcluded })}>
      <Group direction="horizontal" gap={12} verticalAlign="start">
        {isInteractive && (
          <CheckboxInput
            checked={!item.cartExcluded}
            onChange={handleCheckboxChange}
            disabled={isToggleDisabled}
            size="medium"
          />
        )}
        <TileContent>
          <Group direction="vertical" gap={4}>
            {content}
            {attention}
            {actions}
          </Group>
          {item.imageId && (
            <ImageWrapper>
              <Image id={item.imageId} width={80} height={80} />
            </ImageWrapper>
          )}
        </TileContent>
      </Group>
      {price}
    </TileWrapper>
  )
}

export default CartPanelItemTileLayout
